import styled from "styled-components";
import { AircraftSpecifications } from "./AircraftSpecifications";
import { AircraftTypeHeroSection } from "./AircraftTypeHeroSection";
import { AircraftComfort } from "./AircraftComfort";
import { AircraftRequestQuote } from "./AircraftRequestQuote";
import { AircraftRange } from "./AircraftRange";
import { AircraftImages } from "./AircraftImages";
import { MainFooter } from "@/components/ui/Footer/MainFooter";
import { RAVideo, RAButtonBackToTop } from "@/components/customs";

import ReactFullpage from "@fullpage/react-fullpage";
import { Grid } from "antd";
import { useEffect, useState } from "react";
const { useBreakpoint } = Grid;
import { AIRCRAFT_RANGE_STEP } from ".";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function AircraftTypeDetailsSnap({ aircraftType, ...props }) {
	const { headerSolid } = useHeaderSolid();

	const screens = useBreakpoint();
	const [activeSlide, setActiveSlide] = useState(0);
	const [aircraftRangeStep, setAircraftRangeStep] = useState(AIRCRAFT_RANGE_STEP.FIRST);
	const {
		name = "",
		spec_description = "",
		properties = {},
		amenities = {},
		luggages = {},
		background_title = "",
		background_description = "",
		main_button_text = "",
		main_background = {},
		main_background_mobile = {},
		main_background_media_type,
		main_background_video = {},
		seat_maps = [],
		max_range_in_nautical_miles = 0,
		range_routes = [],
		aircraft_list = [],
		banner_desktop = {},
		banner_mobile = {},
		center_airport = {},
		range_title = "",
		range_description = "",
		seat_description = "",
	} = aircraftType || {};

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, [aircraftType]);

	useEffect(() => {
		if (activeSlide === 4) {
			setAircraftRangeStep(AIRCRAFT_RANGE_STEP.FIRST);
		}
		if (activeSlide === 5) {
			setAircraftRangeStep(AIRCRAFT_RANGE_STEP.SECOND);
			// fullpage_api.setAllowScrolling(false)
		}
	}, [activeSlide]);

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
	};

	return (
		<>
			{/* <Menu /> */}
			<div
				id="fixed-introduction"
				style={{
					position: "absolute",
					top: "80px",
					opacity: activeSlide >= 4 && activeSlide <= 5 ? 1 : 0,
					transition: "all 0.6s linear",
					background: "#fff",
				}}
			>
				<BodyAircraftRange>
					<AircraftRange
						className="aircraft-type-range-section"
						range={max_range_in_nautical_miles}
						routes={range_routes}
						step={aircraftRangeStep}
						centerAiport={center_airport}
						description={range_description}
						title={range_title}
						onSwipeDown={() => fullpage_api.moveSectionDown()}
						onSwipeUp={() => fullpage_api.moveSectionUp()}
					/>
				</BodyAircraftRange>
			</div>
			<ReactFullpage
				licenseKey={FULL_PAGE_API_KEY}
				bigSectionsDestination={"top"}
				onLeave={onLeave}
				scrollingSpeed={1100}
				fadingEffect={true}
				normalScrollElements=".ant-picker-panel-container, .ant-modal, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
				credits={{ enabled: false }}
				lazyLoading={false}
				render={({ state, fullpageApi }) => {
					return (
						<ReactFullpage.Wrapper>
							<div className="section" id="aircraft-hero-section">
								<AircraftTypeHeroSection
									background={screens?.xs ? banner_mobile : banner_desktop}
									typeName={name || ""}
									className="aircraft-type-hero-image-section"
								/>
							</div>
							<EachSlide
								className="section fp-auto-height"
								id="aircraft-specification-section"
								style={{
									position: "relative",
									top: activeSlide === 0 ? "-80px" : "0px",
								}}
							>
								<BodySpecificationContainer
									style={{
										width: activeSlide === 0 ? (screens?.md ? "80vw" : "89vw") : "100vw",
									}}
								>
									<AircraftSpecifications
										description={spec_description}
										active={activeSlide >= 1}
										properties={properties}
									/>
								</BodySpecificationContainer>
							</EachSlide>
							<EachSlide className="section" id="aircraft-comfort-section">
								<BodyComfort style={{ width: "100vw" }}>
									<BodyContainer style={{ paddingBottom: 0 }}>
										<AircraftComfort
											amenities={amenities}
											luggages={luggages}
											seatMaps={seat_maps}
											description={seat_description}
										/>
									</BodyContainer>
								</BodyComfort>
							</EachSlide>
							<EachSlide className="section" id="aircraft-request-code-section">
								<BodyRequestCode
									background={screens.xs ? main_background_mobile?.url : main_background?.url}
								>
									<Overlay />
									{main_background_media_type === "VIDEO" ? (
										<div
											style={{
												width: "100%",
												height: "100vh",
												postion: "relative",
											}}
										>
											<RAVideo
												width="100%"
												height="100vh"
												path={
													main_background_video?.url ||
													"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-final.mp4"
												}
											/>
											<BodyContainer
												style={{
													position: "absolute",
													width: "100%",
													height: "100%",
													top: 0,
													left: 0,
												}}
											>
												<AircraftRequestQuote
													title={background_title}
													description={background_description}
													image={main_background}
													image_mobile={main_background_mobile}
													image_media_type={main_background_media_type}
													className="aircraft-type-request-quote-section"
												/>
											</BodyContainer>
										</div>
									) : (
										<BodyContainer>
											<AircraftRequestQuote
												title={background_title}
												description={background_description}
												image={main_background}
												image_mobile={main_background_mobile}
												image_media_type={main_background_media_type}
												className="aircraft-type-request-quote-section"
											/>
										</BodyContainer>
									)}
								</BodyRequestCode>
							</EachSlide>
							<EachSlide className="section" id="aircraft-range-section-first"></EachSlide>
							<EachSlide className="section" id="aircraft-range-section-second"></EachSlide>
							<EachSlide
								className="section fp-auto-height fp-noscroll"
								id="aircraft-images-section"
								style={{ backgroundColor: "#eee" }}
							>
								<BodyAircraftImages>
									<AircraftImages
										className="aircraft-type-images-section"
										aircrafts={aircraft_list}
										typeName={name}
										fullpageApi={fullpageApi}
									/>
								</BodyAircraftImages>
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="footer-section">
								<footer
									style={{
										width: "100%",
										scrollSnapAlign: "end",
									}}
								>
									<MainFooter />
									<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
								</footer>
							</EachSlide>
						</ReactFullpage.Wrapper>
					);
				}}
			/>
		</>
	);
}

const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 120px 80px;
	width: 100%;
	scroll-snap-align: start;
	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 1200px) {
		padding: 90px 80px;
		&.home-utilities-container-outer {
			margin-top: 40px;
		}
	}
	@media (max-width: 767px) {
		padding: 60px 32px;
		&.home-utilities-container-outer {
			margin-top: 30px;
		}
	}
	@media (max-width: 575px) {
		padding: 60px 20px;
		&.home-utilities-container-outer {
			margin-top: 20px;
		}
	}
`;
const BodyAircraftRange = styled.div`
	width: 100%;
`;
const BodySpecificationContainer = styled.div`
	scroll-snap-align: center;
	width: 100%;
	display: flex;
	justify-content: center;
	transition: all 0.6s linear;
`;
const BodyComfort = styled.div`
	scroll-snap-align: start;
	width: 100%;
	display: flex;
	justify-content: center;
	background-image: url("/images/example/aircraft/seat-map-background.png");
	height: 100vh;
	overflow: hidden;
`;
const BodyRequestCode = styled.div`
	scroll-snap-align: start;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	display: flex;
	justify-content: center;
	background: ${(props) => `url(${props.background}) no-repeat top center`};
	background-size: cover;
	position: relative;
`;
const BodyAircraftImages = styled.div`
	scroll-snap-align: start;
	width: 100%;
`;

const Overlay = styled.div`
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0) 100%);
	opacity: 0.800000011920929;
`;

const EachSlide = styled.div`
	width: 100vw;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	transition: all 0.6s linear;
`;
